module.exports = __webpack_public_path__ + "static/media/thermometer-full.a08ad117.svg";